import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal } from 'components';
import cx from 'clsx';
import style from './index.module.css';
import { useCountdown } from '@/hooks';
import { GenerateQRCode, useConfirmQRCode, useQRCodeDelete } from '../../hooks';
import dayjs from 'dayjs';
import message from 'antd/es/message';
import { toastError } from '@/utils';

const { CenterModal } = Modal;

type LoginModalProps = {
  close(): void;
  qrcodeData?: GenerateQRCode;
  onSuccess?: () => void;
};
export const APPLoginModal = ({ close, qrcodeData, onSuccess }: LoginModalProps) => {
  const { t } = useTranslation();

  const { seconds, startCountdown } = useCountdown(90);
  const { mutateAsync: updateQRCodeStatus } = useConfirmQRCode();
  const { mutateAsync: qrcodeDelete } = useQRCodeDelete();

  const [counted, setCounted] = useState(false);
  const login = async () => {
    try {
      await updateQRCodeStatus({
        qrcodeID: qrcodeData?.id || '',
        state: 'confirmed',
      });
      onSuccess?.();
    } catch (err) {
      toastError(err || 'login failed');
    }

    close();
  };
  const closeModal = useCallback(async () => {
    try {
      (await qrcodeData?.id) && qrcodeDelete({ qrcodeID: qrcodeData?.id || '' });

      message.info('Login canceled');
    } catch (err) {
      toastError(err || 'login failed');
    }
    close();
  }, [close, qrcodeData?.id, qrcodeDelete]);

  useEffect(() => {
    if (!counted) {
      setCounted(true);
      startCountdown();
    }
  }, [counted, startCountdown]);

  useEffect(() => {
    if (seconds === 0 && counted) {
      closeModal();
    }
  }, [closeModal, counted, seconds]);
  return (
    <CenterModal onRequestClose={closeModal}>
      <div className={style.qrcodeModal}>
        <div className={style.qrcodeTitle}>{t('APPLoginModal.128n664')}</div>
        <div className={style.qrcodeContainer}>
          <div className={cx(style.refresh, style.location)}>
            <div className={style.label}>{t('APPLoginModal.1c42r1')}</div>
            <div className={style.value}>
              {dayjs.unix(qrcodeData?.create_at || 0).format('YYYY/MM/DD  HH:mm')}
            </div>
          </div>
          <div className={cx(style.refresh, style.location)}>
            <div className={style.label}>{t('APPLoginModal.dcc2dh')}</div>
            <div className={style.value}>{qrcodeData?.location || 'unknown location'}</div>
          </div>
          <div className={cx(style.refresh, style.location)}>
            <div className={style.label}>IP:</div>
            <div className={style.value}>{qrcodeData?.lp || 'unknown IP'}</div>
          </div>
        </div>
        <div className={style.refresh}>
          <div>
            {t('APPLoginModal.gto7o0')}
            <span className={style.seconds}> {seconds} </span>
            {t('APPLoginModal.wky0e7')}
          </div>
        </div>
        <Button
          className={style.login}
          type="primary"
          ghost
          onClick={e => {
            login();
          }}>
          {t('APPLoginModal.11qaxsx')}
        </Button>
        <div className={cx(style.refresh, style.cancel)} onClick={closeModal}>
          {t('APPLoginModal.x9d2fu')}
        </div>
      </div>
    </CenterModal>
  );
};

export default React.memo(APPLoginModal);
